import { useEffect, ReactNode, FC } from 'react';
import { useRouter } from 'next/router';
import { useHistory, useLocation } from '../../hooks/routerCompat';
import { httpClient } from '../../../services/httpClient/httpClient';
import { useAppDispatch } from '../../../store/store';
import { AppRoutes, autenticatedRoutes } from '../../constants/routes';
import { useQuery } from '../../../services/hooks/useQuery';
import { loginWithMagicLink } from '../../../store/slices/me';

interface AuthHandlerProps {
  children: ReactNode;
}

export const AuthHandler: FC<AuthHandlerProps> = ({ children }) => {
  const router = useRouter();
  const location = useLocation();
  const history = useHistory();
  const isLoggedIn = httpClient.isLoggedIn();
  const authenticatedRouteArray = Object.values(autenticatedRoutes) as string[];
  const pathname = location.pathname.split('/')[1];

  const dispatch = useAppDispatch();
  const query = useQuery();
  const magicLinkToken = query.get('ml');

  useEffect(() => {
    if (!router.isReady) return;
    if (magicLinkToken) {
      dispatch(loginWithMagicLink(magicLinkToken));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [magicLinkToken, router.isReady]);

  useEffect(() => {
    if (!router.isReady) return;
    if (!isLoggedIn && authenticatedRouteArray.includes(`/${pathname}`)) {
      history.push(`${AppRoutes.Home}${location.search}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, isLoggedIn, router.isReady]);

  return <div>{children}</div>;
};
